module.exports = __webpack_public_path__ + "static/media/01.f8a53027.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-slideshow/01.jpg
// module id = 360
// module chunks = 0